import { render } from "./CartAddress.vue?vue&type=template&id=4b6b2094"
import script from "./CartAddress.vue?vue&type=script&lang=js"
export * from "./CartAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__